import { en } from "./en";
import { fr } from "./fr";

export const getI18n = (lang?: string | null): typeof en | typeof fr =>
  ({ en, fr }[lang ? lang : "en"] || en);
